const ADMINISTRATOR_LICENSE_LEVELS = [
  'SCHOOL_ADMINISTRATOR',
  'DISTRICT_ADMINISTRATOR',
  'ADMIN',
  'PEEKAPAK_SUPPORT',
  'DEVELOPER',
];

export function canAccessAdministrator(licenseLevel?: string | null) {
  if (!licenseLevel) {
    return false;
  }

  return ADMINISTRATOR_LICENSE_LEVELS.includes(licenseLevel.toUpperCase());
}

export function shouldShowTeacherSchoolName(licenseLevel?: string | null) {
  if (!licenseLevel) {
    return false;
  }

  const normalized = licenseLevel.toUpperCase();
  return (
    normalized === 'DISTRICT_ADMINISTRATOR' ||
    normalized === 'PEEKAPAK_SUPPORT' ||
    normalized === 'ADMIN' ||
    normalized === 'DEVELOPER'
  );
}

export function shouldShowTeacherDistrictName(licenseLevel?: string | null) {
  if (!licenseLevel) {
    return false;
  }

  const normalized = licenseLevel.toUpperCase();
  return normalized === 'PEEKAPAK_SUPPORT' || normalized === 'ADMIN' || normalized === 'DEVELOPER';
}
